import VendorUsersContainer from 'components/modules/Vendors/Users/VendorUsers';

/**
 * Primary UI component for user interaction
 */
const VendorUsers = () => {
  return <VendorUsersContainer />;
};

export default VendorUsers;
